import { Node, mergeAttributes, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { getPdfFileUrl, PdfViewer } from '../../../shared/PdfViewer';

function DocumentEmbedView({ node }) {
  const src = node.attrs.src || node.attrs.data;
  const mimeType = node.attrs.type;
  const title = node.attrs.title || 'Embedded document';
  const pdfUrl = getPdfFileUrl(src, mimeType);

  if (pdfUrl) {
    return (
      <NodeViewWrapper className="pdf-embed-node my-3 w-full" data-drag-handle={false}>
        <PdfViewer fileUrl={pdfUrl} variant="light" />
      </NodeViewWrapper>
    );
  }

  if (!src) return <NodeViewWrapper />;

  return (
    <NodeViewWrapper className="my-3 w-full">
      <iframe
        src={src}
        title={title}
        className="h-[360px] w-full rounded-lg border border-border"
        allowFullScreen
      />
    </NodeViewWrapper>
  );
}

const DocumentEmbed = Node.create({
  name: 'documentEmbed',
  group: 'block',
  atom: true,
  draggable: false,
  selectable: false,

  addAttributes() {
    return {
      src: { default: null },
      data: { default: null },
      type: { default: null },
      title: { default: null },
      width: { default: null },
      height: { default: null }
    };
  },

  parseHTML() {
    return [
      { tag: 'iframe' },
      { tag: 'embed' },
      { tag: 'object' }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const tag = HTMLAttributes.data ? 'object' : 'iframe';
    return [tag, mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(DocumentEmbedView);
  }
});

export default DocumentEmbed;
